import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyle = createUseStyles(({ breakpoints, brandColors }: CmsWrenchTheme) => {
  return {
    rightContent: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(12px)',
      [`@media (min-width: ${breakpoints.md}px)`]: {
        transform: 'translateX(24px)',
      },
      [`@media (min-width: ${breakpoints.lg}px)`]: {
        transform: 'translateX(44px)',
      },
      transition: 'transform 0.3s ease-out',
    },
    leftContent: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(calc(-100% - 12px))',
      [`@media (min-width: ${breakpoints.md}px)`]: {
        transform: 'translateX(calc(-100% - 24px))',
      },
      [`@media (min-width: ${breakpoints.lg}px)`]: {
        transform: 'translateX(calc(-100% - 44px))',
      },
      transition: 'transform 0.3s ease-out',
    },
    pageContent: {
      backgroundColor: brandColors.neutral.smoke,
      height: '798px',
      paddingTop: '246px',
    },
    pathImage: {
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      objectFit: 'contain',
      height: 'auto',
      maxWidth: '356px',
    },
    card: {
      maxWidth: '276px',
      height: '600px',
      [`@media (min-width: ${breakpoints.lg}px)`]: {
        maxWidth: '406px',
      },
    },
    headerText: {
      textWrap: 'balance',
    },
    ctaForm: {
      maxWidth: '400px',
      paddingTop: 0,
    },
    ctaFormWrapper: {
      top: '152px',
    },
    wrapper: {
      maxWidth: '360px',
      [`@media (min-width: ${breakpoints.lg}px)`]: {
        maxWidth: '400px',
      },
      [`@media (min-width: ${breakpoints.xl}px)`]: {
        maxWidth: '480px',
      },
      padding: '20px 40px 24px',
      border: '1px solid #EDEEEE',
      borderRadius: '2px',
      alignItems: 'center',
      backgroundColor: brandColors.background.light2,
    },
    fadeOut: {
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity 0.3s ease-out',
    },
    logoWithText: {
      position: 'absolute',
      backgroundColor: brandColors.background.light2,
      top: 0,
      left: 0,
      right: 0,
    },
    hideLogoWithText: {
      transform: 'translateY(-100%)',
      transition: 'transform 0.3s ease',
    },
    header: {
      position: 'absolute',
      top: '112px',
      left: 0,
      right: 0,
    },
    hide: {
      display: 'none',
    },
    zIndexOverlay: {
      zIndex: 2,
    },
    login: {
      color: '#007FAA',
      textDecoration: 'none',
    },
    loginWrapper: {
      width: '100%',
    },
    logo: {
      position: 'absolute',
      left: 0,
      top: '-32px',
      transform: 'translateY(-100%)',
      width: '198px',
    },
    spaceLeft: {
      marginLeft: '8px',
    },
  };
});

export default useStyle;
